import script from "./HotelSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelSettings.vue?vue&type=script&setup=true&lang=js"

import "./HotelSettings.vue?vue&type=style&index=0&id=fd57613c&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd57613c"]])

export default __exports__